import { render } from "./FreeBadgeSvg.vue?vue&type=template&id=0441676a&ts=true"
import script from "./FreeBadgeSvg.vue?vue&type=script&lang=ts"
export * from "./FreeBadgeSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__